export default __webpack_public_path__ + "static/media/Litto.623420b9.png";